// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DynamicStatesController from "./dynamic_states_controller"
application.register("dynamic-states", DynamicStatesController)

import GenericSortableController from "./generic_sortable_controller"
application.register("generic-sortable", GenericSortableController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import MobileNavViewportAdjustController from "./mobile_nav_viewport_adjust_controller"
application.register("mobile-nav-viewport-adjust", MobileNavViewportAdjustController)

import OrderSummaryController from "./order_summary_controller"
application.register("order-summary", OrderSummaryController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import ProductMediaController from "./product_media_controller"
application.register("product-media", ProductMediaController)

import PromoCodeController from "./promo_code_controller"
application.register("promo-code", PromoCodeController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import ScrollPreservationController from "./scroll_preservation_controller"
application.register("scroll-preservation", ScrollPreservationController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import ShippingToggleController from "./shipping_toggle_controller"
application.register("shipping-toggle", ShippingToggleController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StatesController from "./states_controller"
application.register("states", StatesController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
